import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazySetting = Loadable({
    loader: () => import("pages/Setting/index"),
    loading: () => <PageLoader />,
});

function SettingRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazySetting />} />
        </Routes>
    );
}

export default SettingRoute;
